import { resetLessonEntry } from 'ducks/workItem';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { Divider, Fixed, Flex, Heading, Message, Modal, Text } from 'rebass';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { overflow, PvButton, PvButtonOutline } from 'styles/CustomComponents';
import DataTable from 'components/datatable';
import { showModal } from 'ducks/modal';
import {
  markTheoryLessonEntryDone,
} from 'ducks/applicantsLessonStatus';

const Overflow = styled(Modal)`
  ${overflow}
`;

class SelectUndoneEntryModal extends React.Component {

  markTheoryDone = (entry) => {
    this.props.markTheoryLessonEntryDone({entry, applicants: this.props.applicants});
  };

  showSaveModal = () => {
    const lessonSelected = this.props.lessonSelected;
    const selectedApplicant = this.props.applicant;

    if (~lessonSelected.lesson.lessonType.indexOf('THEORY') || ~lessonSelected.lesson.lessonType.indexOf('TRAINING')) {
      const applicantNameAndTrafiId = `${selectedApplicant.lastName}, ${selectedApplicant.firstNames} (${selectedApplicant.trafiId})`;
      const modalProps = {
        applicantNameAndTrafiId,
        lessonEntry: lessonSelected,
        saveFn: this.markTheoryDone,
        examClasses: [lessonSelected.lesson.examClass],
        lessons: [lessonSelected.lesson],
        applicantId: selectedApplicant.entityId,
        error: this.props.entryError
      };
      this.props.showCompleteUndoneEntryModal(modalProps);
    } else {
      // TODO: Show driving lesson edit screen/modal or what not
    }
  };

  render() {
    const {
      hideModal,
      error,
      applicant,
      lessonSelected,
      resetLessonEntry,
    } = this.props;

    return (
      <React.Fragment>
        <Fixed
          onClick={() => hideModal()}
          top={0}
          right={0}
          bottom={0}
          left={0}
        />
        <Overflow overflow='auto' p={3} width={['90%', '80%', '50vw']}>
          <Heading mb={3} fontSize='19px'><Translate value='search.select_missing_lesson' /></Heading>
          <Flex flexWrap='wrap'>
            <DataTable tableType='SELECT_UNDONE' rows={applicant.lessons} tableHeight='30vh' tableWidth="100%"/>

          </Flex>

          {error && <Message mt={3} bg='red'><Translate value={error} /></Message>}
          <Divider
            my={2}
            w={1}
            borderBottom={2}
            borderColor='grays.1'
          />
          <Text py={2} textAlign='center'>
            <PvButtonOutline
              width='12em'
              my={1}
              ml={2}
              onClick={() => {resetLessonEntry(); hideModal()}}>
              <Translate value='app.cancel' />
            </PvButtonOutline>
            <PvButton
              width='12em'
              my={1}
              ml={2}
              disabled={!lessonSelected}
              onClick={() => this.showSaveModal()}>
              <Translate value='app.select' />
            </PvButton>
          </Text>
        </Overflow>
      </React.Fragment>
    );
  }
};

SelectUndoneEntryModal.propTypes = {
  hideModal: PropTypes.func,
  modalType: PropTypes.string,
  lessons: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    lessonSelected: state.workItem.lessonEntry.selectedEntry,
    applicants: state.applicantLessonStatus.applicants,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  resetLessonEntry: () => resetLessonEntry(),
  showCompleteUndoneEntryModal: (modalProps) => showModal('COMPLETE_UNDONE_ENTRY', modalProps),
  markTheoryLessonEntryDone: (data) => markTheoryLessonEntryDone(data),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectUndoneEntryModal);


// WEBPACK FOOTER //
// ./src/components/modal/SelectUndoneEntryModal.jsx